<template>
        <ak-form
                :bundle="bundle"
                :definition="definition"
                :objectId="objectId"
                :relationString="relationString"
                @save="goToGrid"
                :key="bundle + definition + objectId"
        >
        </ak-form>
</template>

<script>

export default {
    name: 'FormPage',
    computed: {
        bundle() {
            return this.$route.params.bundle;
        },
        definition() {
            return this.$route.params.definition;
        },
        objectId() {
            return this.$route.params.objectId ?
                    this.$route.params.objectId:
                    'new';
        },
        relationString() {
            return this.$route.params.relationString;
        }
    },
    methods: {
        goToGrid(data) {
            this.$router.push({ name: 'grid' , params: {
                    bundle: data.bundleId,
                    gridDefinition: data.definitionId,
                }});
        }
    }
}
</script>
